import { UtilsService } from './utils.service';

export interface UrlConfigType {
  profileServiceUrl: string;
  liveClassServiceHost: string;
  notificationServiceHost: string;
  thirdPartyServiceHost: string;
  progressServiceHost: string;
  courseServiceHost: string;
  profileImagesHost: string;
  gamificationServiceHost: string;
  ssoServiceHost: string;
}

export interface ConfigType extends UrlConfigType {
  authorizationList: string[];
  bearerList: string[];
  bearerExceptionPathList: string[];
  increasedTimeoutList: string[];
}

export function isHostListed(url: string, urlList: string[]) {
  const { hostname: urlHostname } = new URL(url);

  return urlList.some((urlItem) => {
    const { hostname } = new URL(urlItem);
    return hostname === urlHostname;
  });
}

export function urlNeedsBearer(url: string, config: ConfigType) {
  const { pathname } = new URL(url);
  const isNotException = !config.bearerExceptionPathList.includes(pathname);

  const isListed = isHostListed(url, config.bearerList);

  return isNotException && isListed;
}

export function addBearerListToConfig(list: UrlConfigType): ConfigType {
  const bearerList = [
    'profileServiceUrl',
    'liveClassServiceHost',
    'notificationServiceHost',
    'thirdPartyServiceHost',
    'progressServiceHost',
    'courseServiceHost',
    'profileImagesHost',
    'gamificationServiceHost',
    'ssoServiceHost',
  ];

  const bearerExceptionPathList = ['/v1/lfa/purchases', '/v1/sso-sessions'];

  const authorization = ['aiService'];
  const authorizationList = UtilsService.objectEntries(list)
    .filter((item) => authorization.includes(item[0]))
    .map((item) => item[1]);

  const increasedTimeout = ['aiService'];
  const increasedTimeoutList = UtilsService.objectEntries(list)
    .filter((item) => increasedTimeout.includes(item[0]))
    .map((item) => item[1]);

  return {
    ...list,
    authorizationList,
    bearerList: bearerList.map((item) => list[item]),
    bearerExceptionPathList,
    increasedTimeoutList,
  };
}



// WEBPACK FOOTER //
// ./ts/app/shared/auth-interceptor.helper.ts